import clsx from "clsx";

interface InfoPageSectionProps {
  title: string;
  id?: string;
  className?: string;
  children: React.ReactNode;
}

const InfoPageSection = ({ title, id, className, children }: InfoPageSectionProps) => {
  return (
    <section
      id={id}
      className={clsx("[>p]:leading-relaxed mt-10 leading-8 text-secondary", className)}
    >
      <h2 className="mb-4 text-xl font-bold text-black">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
};

export default InfoPageSection;
